export default "__VITE_ASSET__b5817593__"